import { SET_ORGANIZATION_USERS } from "../actions/auth";

export default function auth(
  state = {
    isFetching: false,
    requiresOrganizationSelection: false,
    organizationUsers: [],
    requiresTwoFactor: false,
  },
  action
) {
  switch (action.type) {
    case SET_ORGANIZATION_USERS:
      return Object.assign({}, state, {
        organizationUsers: action.organizationUsers,
      });

    default:
      return state;
  }
}
